<template>
  <div
    class="w-full rounded-medium shadow-theme bg-white py-6 overflow-hidden"
    v-loading="stLoading"
    v-if="colList.length > 0"
  >
    <ul class="w-full flex items-center">
      <li :class="['flex', 'items-center', itemWidth]" v-for="(col, index) of colList" :key="col.prop">
        <div class="ml-10 flex-1 flex flex-col overflow-hidden">
          <p class="flex items-center">
            <span class="mr-1 text-theme-black-650 leading-22 text-medium">{{ col.label }}</span>
            <el-tooltip :content="typeof col.tooltip === 'function' ? col.tooltip(accountingRate) : col.tooltip" placement="top-start" v-if="col.isTooltip">
              <i class="iconfont icon-shuoming text-theme-black-350 text-medium cursor-pointer"></i>
            </el-tooltip>
          </p>
          <div class="my-1 text-large-x font-semibold text-theme-black-850 leading-22">
            <span v-if="col.price">{{ source[col.prop] | formatPrice }}</span>
            <span v-else>{{ source[col.prop] || (col.text ? '' : 0) }}</span>
          </div>
          <p class="text-small leading-none" v-if="col.footerMsg">
            <template v-if="source[col.footerMsg.prop] || col.footerMsg.defaultVal">
              <span
                class="select-none cursor-pointer"
                :class="col.footerMsg.colorName"
                @click="openDetail"
                v-if="col.footerMsg.click"
              >
                {{ source[col.footerMsg.prop] || col.footerMsg.defaultVal }}
              </span>
              <span :class="col.footerMsg.colorName" v-else>
                {{ source[col.footerMsg.prop] || col.footerMsg.defaultVal }}
              </span>
            </template>
            <span class="invisible" v-else>人工导入项目</span>
            <el-tooltip :content="col.footerMsg.tooltip" placement="top-start" v-if="col.footerMsg.isTooltip && col.footerMsg.icon">
              <i class="iconfont icon-shuoming text-theme-black-350 ml-1 text-small cursor-pointer"></i>
            </el-tooltip>
          </p>
          <div class="invisible h-4" v-else />
        </div>
        <div class="w-px h-14 border-l border-solid border-divide-d9 overflow-hidden" v-if="index < colList.length - 1" />
      </li>
    </ul>
    <div class="w-full" v-if="soType === soTypeCode.MESSAGE">
      <p style="background: #F5F5F5;" class="text-medium text-theme-black-650 leading-22 py-2 px-3 mx-10 mt-4">短信内容：{{smsTemplate}}</p>
    </div>
    <li class="w-0 overflow-hidden">
      <adjust-detail-drawer ref="detailDrawer" />
    </li>
  </div>
</template>

<script>
import { filtersMixins } from '@/mixins/relate-settlement'
import { statisticsDetail } from '@/api/cost-settlement/common'
import AdjustDetailDrawer from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/AdjustDetailDrawer'
import { investStatisticsProps, proxyStatisticsProps, messageStatisticsProps, packetStatisticsProps, soTypeCode } from '../../config/cost-sett'
import { getWjawardSummary, getMsgAuditSummary } from '@/api/cost-settlement/approve'
import { getSmsTemps } from '@/api/wenjuan/publish'
import { getTempObjectFn } from '@/views/survey/publish/config/sms-sending'

export default {
  name: 'SettleStatistics',
  mixins: [filtersMixins],
  components: {
    AdjustDetailDrawer
  },
  props: {
    soType: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      soTypeCode,
      stLoading: false,
      source: {
        settleObjTypeText: '',
        linkedSurveyProjectTotal: 0,
        investigatorsNum: 0,
        expectedYuanAmount: 0,
        serviceYuanAmount: 0,
        operationalYuanAmount: 0,
        linkedImportProjectText: '',
        adjustYuanAmountText: ''
      },
      smsTemplate: ''
    }
  },
  computed: {
    itemWidth() {
      switch (true) {
        case this.soType === soTypeCode.INVEST:
          return 'w-1/6'
        case this.soType === soTypeCode.PROXY:
          return 'w-1/4'
          case this.soType === soTypeCode.MESSAGE || this.soType === soTypeCode.PACKET:
          return 'w-1/5'
        default:
          return ''
      }
    },
    colList() {
      switch (true) {
        case this.soType === soTypeCode.INVEST:
          return investStatisticsProps
        case this.soType === soTypeCode.PROXY:
          return proxyStatisticsProps
          case this.soType === soTypeCode.MESSAGE:
          return messageStatisticsProps
          case this.soType === soTypeCode.PACKET:
          if(this.$route.query.auditStatus == 1) {
            packetStatisticsProps.pop()
          }
          return packetStatisticsProps
        default:
          return []
      }
    },
    accountingRate(){
      return this.$store.getters.accountingRate
    }
  },
  watch: {
    soType() {
      this.setSOTypeText()
    }
  },
  mounted() {
    this.getStatistics()
    this.setSOTypeText()
  },
  methods: {
    setSOTypeText() {
      switch (true) {
        case this.soType === soTypeCode.PROXY:
          this.source.settleObjTypeText = '代理'
          break
        case this.soType === soTypeCode.INVEST:
          this.source.settleObjTypeText = '调查员'
          break
        default:
          this.source.settleObjTypeText = ''
      }
    },
    getPacketType(type){
      let str='-'
      switch (type) {
        case 0:
          str = '定额红包'
          break
        case 1:
         str = '随机金额红包'
          break
        case 2:
         str = '随机定额红包'
          break
      }
      return str
    },
    getPayType(type){
      let str='-'
      switch (type) {
        case 1:
          str = '答题红包'
          break
        case 2:
         str = '分享红包'
          break
      }
      return str
    },
    getStatistics() {
      this.stLoading = true
      if(this.soType === soTypeCode.PACKET){
        getWjawardSummary(this.$route.params.id).then(res => {
          this.source = res?.data?.data || {}
          this.source.payType = this.getPayType(this.source.payType)
          this.source.redPacketType = this.getPacketType(this.source.redPacketType)
        }).catch(() => {
          this.$message.error('获取统计数据失败')
        })
        .finally(() => {
          this.stLoading = false
        })
      }else if(this.soType === soTypeCode.MESSAGE) {
        getMsgAuditSummary(this.$route.params.id).then(res => {
          this.source = res?.data?.data || {}
          this.source.payType = this.getPayType(this.source.payType)
          this.source.redPacketType = this.getPacketType(this.source.redPacketType)
          this.getSmsTemps()
        }).catch(() => {
          this.$message.error('获取统计数据失败')
        })
        .finally(() => {
          this.stLoading = false
        })
      } else{
        statisticsDetail(this.$route.params.id)
        .then(res => {
          const dt = res?.data?.data || {}
          this.setSource(dt)
        })
        .catch(() => {
          this.$message.error('获取统计数据失败')
        })
        .finally(() => {
          this.stLoading = false
        })
      }
    },
    setSource(dt) {
      const {
        linkedImportProjectNum = 0,
        linkedInvestigateProjectNum = 0,
        linkedSurveyProjectNum = 0,
        investigatorsNum = 0,
        expectedYuanAmount = 0,
        serviceYuanAmount = 0,
        operationalYuanAmount = 0,
        adjustYuanAmount = 0
      } = dt
      this.source.linkedSurveyProjectTotal = linkedImportProjectNum + linkedInvestigateProjectNum + linkedSurveyProjectNum
      this.source.investigatorsNum = investigatorsNum
      this.source.expectedYuanAmount = expectedYuanAmount
      this.source.serviceYuanAmount = serviceYuanAmount
      this.source.operationalYuanAmount = operationalYuanAmount
      this.source.linkedImportProjectText = +linkedImportProjectNum ? `含人工导入项目 ${linkedImportProjectNum} 个` : ''
      const adyAmount = Number.isNaN(+adjustYuanAmount) ? 0 : +adjustYuanAmount
      const adyAmountFixed = adyAmount === 0 ? '0.00' : adyAmount < 0 ? adyAmount.toFixed(2) : `+${adyAmount.toFixed(2)}`
      this.source.adjustYuanAmountText = +adyAmountFixed !== 0 ? `含补扣款 ${adyAmountFixed}` : ''
      // 单独处理补扣款显隐
      if (this.soType === soTypeCode.INVEST) {
        const col = this.colList.find(f => f.prop === 'expectedYuanAmount')
        if (col) {
          col.footerMsg.isTooltip = !!this.source.adjustYuanAmountText
        }
      } else if (this.soType === soTypeCode.PROXY) {
        const col = this.colList.find(f => f.prop === 'operationalYuanAmount')
        if (col) {
          col.footerMsg.isTooltip = !!this.source.adjustYuanAmountText
        }
      }
    },
    openDetail() {
      this.$refs.detailDrawer.open();
    },
    getSmsTemps() {
      getSmsTemps().then(res => {
        const list = res.data.data
        console.log('list',list)
        console.log('this.source.smsTemplateType', this.source.smsTemplateType)
        // const objectFn = getTempObjectFn(list)
        // const fn = objectFn[`smsTempText${this.source.smsTemplateType}`]
        this.$nextTick(()=>{
          this.smsTemplate = list.find(item=> item.id === this.source.smsTemplateType).baseContent
        })
      })
    }
  }
}
</script>
